import type React from 'react'
import { isValidElement } from 'react'

import type { Align } from './Cell'
import styles from './Cell.module.scss'

export const sizeClassMap = new Map([
  ['x-small', styles.containerXSmall],
  ['small', styles.containerSmall],
  ['medium', styles.containerMedium],
  ['large', styles.containerLarge],
])

export const getAlignment = ({ align, children }: GetAlignmentArgs) => {
  if (align !== 'auto') {
    return align
  }

  if (isValidElement(children)) {
    if (typeof children.props?.children === 'string') {
      return calculateNumericalCellAlignment(children.props?.children)
    }
    return 'left'
  }

  return calculateNumericalCellAlignment(String(children))
}

///////// IMPLEMENTATION /////////

type GetAlignmentArgs = {
  align: Align
  children: React.ReactNode
}

const calculateNumericalCellAlignment = (text: string) => {
  const excludedSymbolsRegex = /[£€$%]/g
  const strippedText = text.replace(excludedSymbolsRegex, '')

  const numericalCount = strippedText.match(/[0-9]/g)?.length ?? 0
  return numericalCount > strippedText.length / 2 ? 'right' : 'left'
}
